import type { HTMLChakraProps } from '@chakra-ui/react';
import type { AddressOrNative, ChainId } from '@cronos-app/sdk';
import type { FC } from 'react';

export enum Token {
  /** a non-graduated agentfun token to be bought from bonding curve  */
  Bonding = 'Bonding',
  /** a graduated agentfun token to be bought from H2  */
  Agent = 'Agent',

  // Normal Tokens
  zkCRO = 'zkCRO',
  wzkCRO = 'wzkCRO',
  agentFun = 'agentFun',
  vUSD = 'vUSD',
  wCRO = 'wCRO',
}

export type NormalToken = Exclude<Token, Token.Bonding | Token.Agent>;
export type TokenOnH2 = Exclude<Token, Token.Bonding>;
export type TokenOnBonding = Exclude<Token, Token.Agent>;

export function isNormalToken(token: Token): token is NormalToken {
  return token !== Token.Bonding && token !== Token.Agent;
}

export function isTokenOnH2(token: Token): token is TokenOnH2 {
  return token !== Token.Bonding;
}

export function isTokenOnBonding(token: Token): token is TokenOnBonding {
  return token !== Token.Agent;
}

export interface TokenConfig {
  readonly type: Token;
  readonly symbol: string;
  readonly address: AddressOrNative;
  readonly decimals: number;
  readonly displayDecimals: number;
  readonly Icon: FC<HTMLChakraProps<'div'>> | null;
}

export type TokenRegister = (desiredNetwork: ChainId) => TokenConfig;
